<template>
  <div class="credit-list-wrap">
    <template-search-read :readApi="listApi"
                          :defaultSortBy="defaultSortBy"
                          :reload="reload"
                          :initialSearchFilter="initialSearchFilter"
                          service="loginHistory"
                          @searchFilter="getSearchFilter"
                          >
      <ui-button :color="'purple'"
                 @click="toggleExcel(true)">
        <i class="xi-view-list"></i> 엑셀 다운로드
      </ui-button>
    </template-search-read>
    <excel-column-select :excelDownload="excelDownload"
                         :metaApi="excelListMetaApi"
                         :listApi="listApi"
                         :searchFilter="searchFilter"
                         @export="excelExport"
                         @close="toggleExcel(false)"/>
  </div>
</template>

<script>
import TemplateSearchRead from '@/components/_template/SearchRead'
import UiButton from '@/components/_ui/UiButton'

import Excel from '@/utils/excel-export'
import ExcelColumnSelect from '@/components/_template/ExcelColumnSelect'
import { EventBus } from '@/utils/event-bus'
import { format } from 'date-fns'
import { getLoginHistoryList, getLoginHistoryListExcelMeta } from '@/api/loginHistory'
import { STORAGE_ITEM } from '@/utils/constants'

export default {
  name: 'LoginHistoryList',
  components: {
    ExcelColumnSelect,
    TemplateSearchRead,
    UiButton
  },
  created () {
    const localStorageData = localStorage.getItem(STORAGE_ITEM.searchData)
    if (localStorageData !== '{}' || localStorageData !== 'null') {
      const searchData = JSON.parse(localStorageData)
      if (searchData && searchData.userId) {
        this.initialSearchFilter = {}
        this.initialSearchFilter.userId = searchData.userId
        this.initialSearchFilter.userIdExact = true
      }
    }
    localStorage.setItem(STORAGE_ITEM.searchData, null)
  },
  methods: {
    reloadList () {
      this.reload++
    },
    toggleExcel (value = false) {
      let excelAvailable = false
      for (const key in this.searchFilter) {
        if (key) {
          excelAvailable = true
        }
      }
      if (excelAvailable) {
        this.excelDownload = value
      } else {
        alert('검색 옵션을 넣어주세요.')
      }
    },
    excelExport (col, data, selectCol) {
      const fileName = 'eagle_login_history_list'
      const excel = new Excel()
      excel.setExcelData('loginHistory', col, data || [], selectCol, {})
        .then(result => {
          excel.download(fileName)
          this.excelDownload = false
          EventBus.$emit('onLoading', false)
        })
    },
    getSearchFilter (value) {
      this.searchFilter = value
    },
    getYesterDay () {
      let currenDate = new Date()
      currenDate.setDate(currenDate.getDate() - 1)
      return format(currenDate, 'yyyy-MM-dd')
    }
  },
  data () {
    return {
      reload: 0,
      apiParam: null,

      listApi: getLoginHistoryList,
      excelListMetaApi: getLoginHistoryListExcelMeta,
      defaultSortBy: '-loginDate',
      show: {
        insert: false
      },
      excelDownload: false,
      searchFilter: {},
      initialSearchFilter: {
        loginDate: {
          start: this.getYesterDay(),
          end: this.getYesterDay()
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
